export default from './TodaysRates';



// WEBPACK FOOTER //
// ./src/components/TodaysRates/index.js